var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.18362C16 7.63982 15.955 7.09309 15.8591 6.55811H8.16107V9.63865H12.5693C12.3864 10.6322 11.7986 11.5111 10.938 12.0696V14.0684H13.568C15.1123 12.6751 16 10.6175 16 8.18362Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16091 16C10.362 16 12.2183 15.2916 13.5708 14.0688L10.9408 12.07C10.2091 12.5579 9.26447 12.8342 8.1639 12.8342C6.03474 12.8342 4.22945 11.4262 3.5817 9.5332H0.867767V11.5938C2.25322 14.2951 5.07512 16 8.16091 16Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.57905 9.53314C3.23718 8.5396 3.23718 7.46376 3.57905 6.47023V4.40967H0.868147C-0.289382 6.67011 -0.289382 9.33326 0.868147 11.5937L3.57905 9.53314Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16091 3.16633C9.32445 3.1487 10.449 3.57786 11.2917 4.36563L13.6218 2.08167C12.1463 0.723645 10.1881 -0.0229765 8.16091 0.000539092C5.07512 0.000539092 2.25322 1.70542 0.867767 4.40972L3.5787 6.47028C4.22345 4.57433 6.03174 3.16633 8.16091 3.16633Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.8d57c179d43bacc65d8d268a055cc97e.svg";
export { ForwardRef as ReactComponent };